/**
 * Stopwatch - Professional Online Stopwatch with Lap Timer
 * Free online stopwatch with millisecond precision and keyboard shortcuts
 */
(function() {
    'use strict';

    let startTime = 0;
    let elapsedTime = 0;
    let timerInterval = null;
    let isRunning = false;
    let lapNumber = 0;
    let lastLapTime = 0;
    let previousLapDuration = 0;
    
    const display = document.getElementById('stopwatch-display');
    const timerCard = document.getElementById('timer-card');
    const btnStart = document.getElementById('btn-start');
    const btnPause = document.getElementById('btn-pause');
    const btnLap = document.getElementById('btn-lap');
    const btnReset = document.getElementById('btn-reset');
    const btnFullscreen = document.getElementById('btn-fullscreen');
    const btnCloseFullscreen = document.getElementById('btn-close-fullscreen');
    const btnClearLaps = document.getElementById('btn-clear-laps');
    const lapSection = document.getElementById('lap-section');
    const lapTbody = document.getElementById('lap-tbody');

    /**
     * Format time in HH:MM:SS.mmm format
     * @param {number} ms - Milliseconds
     * @returns {string} Formatted time string
     */
    function formatTime(ms) {
        const totalSeconds = Math.floor(ms / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        const milliseconds = Math.floor(ms % 1000);

        return hours.toString().padStart(2, '0') + ':' +
               minutes.toString().padStart(2, '0') + ':' +
               seconds.toString().padStart(2, '0') + '.' +
               milliseconds.toString().padStart(3, '0');
    }

    /**
     * Format time difference with +/- sign
     * @param {number} ms - Milliseconds difference
     * @returns {string} Formatted difference string
     */
    function formatTimeDiff(ms) {
        const sign = ms >= 0 ? '+' : '-';
        const absMs = Math.abs(ms);
        return sign + formatTime(absMs);
    }

    /**
     * Update the stopwatch display and document title
     */
    function updateDisplay() {
        const currentTime = Date.now();
        elapsedTime = (currentTime - startTime);
        display.textContent = formatTime(elapsedTime);
        document.title = '\u23F1 ' + formatTime(elapsedTime) + ' - Stopwatch';
    }

    /**
     * Start the stopwatch
     */
    function start() {
        if (!isRunning) {
            startTime = Date.now() - elapsedTime;
            timerInterval = setInterval(updateDisplay, 10);
            isRunning = true;
            btnStart.classList.add('d-none');
            btnPause.classList.remove('d-none');
            btnLap.disabled = false;
        }
    }

    /**
     * Pause the stopwatch
     */
    function pause() {
        if (isRunning) {
            clearInterval(timerInterval);
            isRunning = false;
            btnStart.classList.remove('d-none');
            btnPause.classList.add('d-none');
        }
    }

    /**
     * Reset the stopwatch to zero
     */
    function reset() {
        clearInterval(timerInterval);
        isRunning = false;
        elapsedTime = 0;
        lapNumber = 0;
        lastLapTime = 0;
        previousLapDuration = 0;
        display.textContent = '00:00:00.000';
        document.title = 'Free Online Stopwatch';
        btnStart.classList.remove('d-none');
        btnPause.classList.add('d-none');
        btnLap.disabled = true;
    }

    /**
     * Record a lap time
     */
    function recordLap() {
        if (!isRunning && elapsedTime === 0) return;
        
        lapNumber++;
        const currentLapDuration = elapsedTime - lastLapTime;
        
        // Calculate difference from previous lap
        let diffDisplay = '-';
        let diffClass = '';
        if (lapNumber > 1) {
            const diff = currentLapDuration - previousLapDuration;
            diffDisplay = formatTimeDiff(diff);
            diffClass = diff > 0 ? 'text-danger' : 'text-success';
        }
        
        const row = document.createElement('tr');
        row.innerHTML = '<td>' + lapNumber + '</td>' +
                        '<td class="lap-time">' + formatTime(currentLapDuration) + '</td>' +
                        '<td>' + formatTime(elapsedTime) + '</td>' +
                        '<td class="lap-diff ' + diffClass + '">' + diffDisplay + '</td>';
        lapTbody.insertBefore(row, lapTbody.firstChild);
        lapSection.classList.remove('d-none');
        
        // Store for next lap comparison
        previousLapDuration = currentLapDuration;
        lastLapTime = elapsedTime;
    }

    /**
     * Clear all lap times
     */
    function clearLaps() {
        lapTbody.innerHTML = '';
        lapSection.classList.add('d-none');
        lapNumber = 0;
        lastLapTime = 0;
        previousLapDuration = 0;
    }

    /**
     * Enter fullscreen mode
     */
    function enterFullscreen() {
        const elem = timerCard;
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
        }
    }

    /**
     * Exit fullscreen mode
     */
    function exitFullscreen() {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
    }

    /**
     * Toggle fullscreen mode
     */
    function toggleFullscreen() {
        if (!document.fullscreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
            enterFullscreen();
        } else {
            exitFullscreen();
        }
    }

    // Event Listeners
    btnStart.addEventListener('click', start);
    btnPause.addEventListener('click', pause);
    btnLap.addEventListener('click', recordLap);
    btnReset.addEventListener('click', reset);
    btnFullscreen.addEventListener('click', toggleFullscreen);
    btnCloseFullscreen.addEventListener('click', exitFullscreen);
    btnClearLaps.addEventListener('click', clearLaps);

    // Keyboard Shortcuts
    document.addEventListener('keydown', function(e) {
        // Ignore if user is typing in an input field
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;

        switch(e.key.toLowerCase()) {
            case ' ':
                e.preventDefault();
                if (isRunning) pause(); else start();
                break;
            case 'l':
                e.preventDefault();
                recordLap();
                break;
            case 'r':
                e.preventDefault();
                reset();
                break;
            case 'f':
                e.preventDefault();
                toggleFullscreen();
                break;
        }
    });

    // Fullscreen change event - handle all browser prefixes
    function onFullscreenChange() {
        const isFullscreen = document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
        if (isFullscreen) {
            btnFullscreen.innerHTML = '<i class="bi bi-fullscreen-exit"></i><span>Exit</span>';
            timerCard.classList.add('is-fullscreen');
        } else {
            btnFullscreen.innerHTML = '<i class="bi bi-fullscreen"></i><span>Fullscreen</span>';
            timerCard.classList.remove('is-fullscreen');
        }
    }

    document.addEventListener('fullscreenchange', onFullscreenChange);
    document.addEventListener('webkitfullscreenchange', onFullscreenChange);
    document.addEventListener('msfullscreenchange', onFullscreenChange);

    // Restore state from localStorage on page load
    const savedState = localStorage.getItem('stopwatch-state');
    if (savedState) {
        const state = JSON.parse(savedState);
        if (state.isRunning) {
            elapsedTime = state.elapsedTime + (Date.now() - state.savedTime);
            start();
        }
    }

    // Save state before page unload
    window.addEventListener('beforeunload', function() {
        if (isRunning) {
            localStorage.setItem('stopwatch-state', JSON.stringify({
                isRunning: true,
                elapsedTime: elapsedTime,
                savedTime: Date.now()
            }));
        } else {
            localStorage.removeItem('stopwatch-state');
        }
    });
})();
